export default __webpack_public_path__ + "static/media/logo_american_blanco.b7eac054.png";